import type { ComponentType } from "react";
import { FallbackPreviewCard } from "./PreviewCards/FallbackPreviewCard";
import { InvitationLinkCard } from "./PreviewCards/InvitationLinkCard";
import { MemberCard } from "./PreviewCards/MemberCard";
import { MemberProfileCard } from "./PreviewCards/MemberProfileCard";
import { MemberTagCard } from "./PreviewCards/MemberTagCard";
import { ProfileFieldCard } from "./PreviewCards/ProfileFieldCard";
import { SpaceCard } from "./PreviewCards/SpaceCard";
import { SpaceGroupCard } from "./PreviewCards/SpaceGroupCard";

type PreviewCardParams = Record<string, string> & {
  members?: Array<{ name?: string; email?: string }>;
};

interface PreviewCardComponentProps {
  params: PreviewCardParams;
  title: string;
  url: string;
}

interface PreviewCardProps extends PreviewCardComponentProps {
  resource: string;
}

const PREVIEW_COMPONENTS: Record<
  string,
  ComponentType<PreviewCardComponentProps>
> = {
  member_profile: MemberProfileCard,
  invitation_link: InvitationLinkCard,
  member: MemberCard,
  profile_field: ProfileFieldCard,
  space_group: SpaceGroupCard,
  member_tag: MemberTagCard,
  space: SpaceCard,
};

export const PreviewCard = ({
  resource,
  params,
  url,
  title,
}: PreviewCardProps) => {
  const Component = PREVIEW_COMPONENTS[resource];

  if (!Component) {
    return <FallbackPreviewCard params={params} url={url} title={title} />;
  }

  return <Component params={params} url={url} title={title} />;
};
